module.exports = __webpack_public_path__ + "img/compare-content.7e2423f7.png";